import { useState } from 'react';
import { Sentry } from '@/lib/sentry';
import { Button } from '@/components/ui/Button';
import { PageContainer } from '@/components/layout';

export function DebugSentryPage() {
  const [sent, setSent] = useState(false);

  function handleCaptureException() {
    Sentry.captureException(
      new Error('Sentry frontend test — if you see this in Sentry, it works!'),
    );
    setSent(true);
  }

  return (
    <PageContainer variant="narrow" className="p-8 max-w-lg">
      <h1 className="text-2xl font-bold mb-2">Sentry Debug</h1>
      <p className="text-muted-foreground mb-6">
        Send a test error to verify that Sentry is receiving events from the
        frontend.
      </p>
      <Button onClick={handleCaptureException}>Send Test Error</Button>
      {sent && (
        <p className="mt-4 text-sm text-success">
          Test error sent. Check your Sentry dashboard.
        </p>
      )}
    </PageContainer>
  );
}
